"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.US_STATES = exports.TICKLED_PINK = exports.TEXT_WHITE = exports.TEXT_GREY = exports.TEXT_BLACK = exports.ROUSING_RED = exports.MAX_INTEGER = exports.MAX_FILE_SIZE_MB = exports.LIGHT_GREY = exports.GROOVY_GREEN = exports.GREY = exports.GENDER_OPTIONS = exports.FULL_DATE_TIME = exports.ERGO_BLUE = exports.DARK_GREY = exports.DARK_BLUE = exports.COUPON_USES = exports.BUOYANT_BLUE = exports.BLUE = exports.APPEALING_ORANGE = void 0;
exports.getLocaleTimeZone = getLocaleTimeZone;

var _luxon = require("luxon");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* --- Color Palette --- */
// Core Colors
const DARK_BLUE = '#1C4F99';
exports.DARK_BLUE = DARK_BLUE;
const BLUE = '#0063d3';
exports.BLUE = BLUE;
const ERGO_BLUE = '#40a4e9';
exports.ERGO_BLUE = ERGO_BLUE;
const DARK_GREY = '#8F8F8F';
exports.DARK_GREY = DARK_GREY;
const GREY = '#bebebe';
exports.GREY = GREY;
const LIGHT_GREY = '#e0e1e3'; // Fun Colors

exports.LIGHT_GREY = LIGHT_GREY;
const ROUSING_RED = '#eb0000';
exports.ROUSING_RED = ROUSING_RED;
const APPEALING_ORANGE = '#ff6600';
exports.APPEALING_ORANGE = APPEALING_ORANGE;
const GROOVY_GREEN = '#a1e23d';
exports.GROOVY_GREEN = GROOVY_GREEN;
const BUOYANT_BLUE = '#2ec0ff';
exports.BUOYANT_BLUE = BUOYANT_BLUE;
const TICKLED_PINK = '#ff56d6'; // Basics

exports.TICKLED_PINK = TICKLED_PINK;
const TEXT_BLACK = 'black';
exports.TEXT_BLACK = TEXT_BLACK;
const TEXT_WHITE = 'white';
exports.TEXT_WHITE = TEXT_WHITE;
const TEXT_GREY = '#424242';
/* --- Color Palette --- */

exports.TEXT_GREY = TEXT_GREY;
const US_STATES = ['AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FM', 'FL', 'GA', 'GU', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MH', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'MP', 'OH', 'OK', 'OR', 'PW', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VI', 'VA', 'WA', 'WV', 'WI', 'WY'];
exports.US_STATES = US_STATES;
const GENDER_OPTIONS = [{
  display: 'Female',
  enum: 'FEMALE'
}, {
  display: 'Male',
  enum: 'MALE'
}, {
  display: 'Gender Non-Conforming',
  enum: 'GENDER_NON-CONFORMING'
}, {
  display: 'Prefer Not to Answer',
  enum: 'PREFER_NOT_TO_ANSWER'
}];
exports.GENDER_OPTIONS = GENDER_OPTIONS;
const COUPON_USES = [{
  display: 'Ergonar',
  enum: 'ERGONAR'
}, {
  display: 'Training',
  enum: 'TRAINING'
}];
exports.COUPON_USES = COUPON_USES;
const MAX_INTEGER = 2147483647;
exports.MAX_INTEGER = MAX_INTEGER;
const MAX_FILE_SIZE_MB = 20;
exports.MAX_FILE_SIZE_MB = MAX_FILE_SIZE_MB;

function getLocaleTimeZone() {
  var _DateTime$now$toLocal;

  return (_DateTime$now$toLocal = _luxon.DateTime.now().toLocaleString({
    day: '2-digit',
    timeZoneName: 'short'
  })) === null || _DateTime$now$toLocal === void 0 ? void 0 : _DateTime$now$toLocal.slice(4);
}

const FULL_DATE_TIME = _objectSpread(_objectSpread({}, _luxon.DateTime.DATETIME_MED), {}, {
  weekday: 'short',
  timeZoneName: 'short'
});

exports.FULL_DATE_TIME = FULL_DATE_TIME;